// extracted by mini-css-extract-plugin
module.exports = {"icon":"ResponseMessageDialog_icon__OA1qf"};